module.exports = __webpack_public_path__ + "bin/f4119660465bf7653c4abc7ecb55d21b.png";